module.exports = "query chancelleries{chancelleries{list{id powerBI}}}"